
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Report_Adv03Dialog extends Serenity.EntityDialog<Report_Adv03Row, any> {
        protected getFormKey() { return Report_Adv03Form.formKey; }
        protected getIdProperty() { return Report_Adv03Row.idProperty; }
        protected getLocalTextPrefix() { return Report_Adv03Row.localTextPrefix; }
        protected getNameProperty() { return Report_Adv03Row.nameProperty; }
        protected getService() { return Report_Adv03Service.baseUrl; }
        protected getDeletePermission() { return Report_Adv03Row.deletePermission; }
        protected getInsertPermission() { return Report_Adv03Row.insertPermission; }
        protected getUpdatePermission() { return Report_Adv03Row.updatePermission; }

        protected form = new Report_Adv03Form(this.idPrefix);

    }
}